import React from 'react'
import { Row, Image } from 'antd'
import { CustomText, CustomCol } from 'src/components'
import type { BaseType } from 'antd/lib/typography/Base'

interface CustomProjectColumnProps {
  name: string,
  imageSource: string
  type?: BaseType
  year?: number
}

const CustomProjectColumn: React.FC<CustomProjectColumnProps> = (props) => {
  const { name, imageSource, type, year = 'secondary' } = props

  const textClassName = name?.length < 12 ? 'mt-4 ml-4' : 'mt-1'
  const vintageYear = typeof year == 'number' ? year : ''
  return <Row>
    {props.imageSource ? <>
      <CustomCol md={4} lg={8}>
        <Image
          width={50}
          height={50}
          alt='project-image'
          src={imageSource}
          style={{ borderRadius: '10px' }}
          preview={{ src: imageSource }}
        />
      </CustomCol>
      <CustomCol md={8} lg={16} style={{ display: 'flex', flexDirection: 'column', textAlign: 'center', marginTop: '-5px' }}>
        <CustomText
          type={type}
          className={textClassName}
          label={name}
          style={{ color: '#00000073' }}
        />
        <CustomText
          type={type}
          label={vintageYear}
          style={{ color: '#00000073' }}
        />
      </CustomCol>
    </> : <CustomCol md={24}>
      <CustomText
        type={type}
        className={`${textClassName} mt-4`}
        label={name}
        style={{ color: '#00000073' }}
      />
      <CustomText
        type={type}
        label={vintageYear}
        style={{ color: '#00000073' }}
      />
    </CustomCol>}
  </Row>
}

export default CustomProjectColumn
